import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IAppointmentTabEnum } from '../../enums/appointments_tab_enum';
import { UpcomingAppointmentsQuery } from '../../queries/upcoming_appointments_query';
import { AppointmentRemindersServant } from '../../servants/appointment_reminders_servant';
import { MyAppointmentsService } from '../../services/my_appointments_service';
import { IAppointment } from '../../types/appointment_interfaces';

export class MyAppointmentsContoller {
  constructor(
    private ngMyAppointmentsService: MyAppointmentsService,
    private AppointmentTabEnum: IAppointmentTabEnum
  ) {}

  $onInit(): void {
    this.ngMyAppointmentsService.loadUpcomingAppoinments();
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/components/my_appointments/my_appointments.ts